// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"j1-z"};